import {createStateMaker} from '@shared/helpers/object'

import {BannerArea, BannerAreaType, BannerCardType, BannerCardTypeType, PayMethod} from '@web/core/constants'
import {
    naverHyundaiCard,
    HYUNDAI_CARD_PROMOTION_BENEFIT_URL,
    LOTTE_CARD_PROMOTION_BENEFIT_URL,
    SAMSUNG_TAPTAP_CARD_REGISTER_URL,
    SHINHAN_LINE_FRIENDS_BENEFIT_URL,
    NAVER_PAY_MONEY_CARD_BENEFIT_URL,
    KOOKMIN_HAPPINESS_SAMSUNG_URL,
} from '@web/core/urls'

import {AvailableAreaInfo, BannerState, ExposureAreaInfo, ExposureAreaInfoList, BannerView} from './interfaces'

export function getInitialBanner() {
    return Object.keys(BannerArea).reduce<ExposureAreaInfoList>((acc, originArea) => {
        const area = originArea as BannerAreaType
        acc[area] = []
        return acc
    }, {})
}

export function getInitialAvailableBanner() {
    return Object.keys(BannerArea).reduce<AvailableAreaInfo>((acc, originArea) => {
        const area = originArea as BannerAreaType
        /** 기본적으로는 항상 0번 index의 banner를 사용 */
        acc[area] = 0
        return acc
    }, {})
}

export const getInitialState = (): BannerState => ({
    bannerArea: getInitialBanner(),
    availableBannerArea: getInitialAvailableBanner(),
    expectedTotalRewardPointBySubscribing: 0,
    expectedTotalRewardPointOfTodayOrders: 0,
    plccExpectedPercentage: 0,
    plccMaximumAmount: 0,
    membershipRewardPointAmount: 0,
    payMethodType: PayMethod.NONE,
    userName: null,
    naverBenefit: null,
    shouldMobileAreaPopupBannerRender: true,
    userNickName: null,
    shouldNoCertificationRender: false,
})

export const makeMock = createStateMaker<BannerState>(getInitialState)

/**
 * 조회 API 에서 내려받은 배너정보를 관리하고 있는 BannerArea 상수로 필터링하는 함수
 */
export function getBannerArea(banners: ExposureAreaInfoList) {
    return Object.keys(banners).reduce<ExposureAreaInfoList>((acc, receivedArea) => {
        const area = receivedArea as BannerAreaType
        if (Object.keys(BannerArea).includes(area)) {
            acc[area] = banners[area]
        }
        return acc
    }, {})
}
export const getPlateBannerLandingUrl = ({exposureCardType}: {exposureCardType: BannerCardTypeType}): Maybe<string> => {
    switch (exposureCardType) {
        case BannerCardType.HYUNDAI_MEMBERSHIP:
            return naverHyundaiCard()
        case BannerCardType.SAMSUNG_TAPTAP:
        case BannerCardType.SAMSUNG_PROMOTION:
            return SAMSUNG_TAPTAP_CARD_REGISTER_URL
        case BannerCardType.NAVERPAY_MONEYCARD:
            return NAVER_PAY_MONEY_CARD_BENEFIT_URL
        case BannerCardType.LOTTE_NPAY_LOCA:
        case BannerCardType.LOTTE_PROMOTION:
            return LOTTE_CARD_PROMOTION_BENEFIT_URL
        case BannerCardType.HYUNDAI_PROMOTION:
            return HYUNDAI_CARD_PROMOTION_BENEFIT_URL
        case BannerCardType.SHINHAN_LINE_FRIENDS:
        case BannerCardType.SHINHAN_PROMOTION:
            return SHINHAN_LINE_FRIENDS_BENEFIT_URL
        case BannerCardType.KOOKMIN_HAPPINESS_SAMSUNG:
            return KOOKMIN_HAPPINESS_SAMSUNG_URL
        default:
            return null
    }
}

/**
 * 단일배너정보를 banner slice에 맞게 convert 해주는 함수
 * @param bannerInfo 단일배너정보
 */
export function convertBannerInfo(bannerInfo: Maybe<ExposureAreaInfo>): ExposureAreaInfoList {
    if (bannerInfo) {
        return Object.keys(bannerInfo).reduce<ExposureAreaInfoList>((acc, originArea) => {
            const area = originArea as BannerAreaType
            if (Object.keys(BannerArea).includes(area)) {
                acc[area] = [bannerInfo[area] as BannerView]
            }
            return acc
        }, {})
    }
    return getInitialBanner()
}
